module.exports = __webpack_public_path__ + "static/img/00_jzf.da9244f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessPlatform/swiperImg/secondLine/00_jzf.png
// module id = N8/y
// module chunks = 0